import { useLocation } from "react-router-dom";
import ModHeader from "../Mod/ModTable/ModHeader";
import { useDispatch, useSelector } from "react-redux";
import ToggleTabs from "../Mod/ModTable/ChartTableToggle";
import { useEffect, useState, useCallback, useRef } from "react";
import { Calendar, Clock, Download } from "lucide-react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import {
  fetchModGDamData,
  fetchModDamData,
  fetchModDemandData,
  fetchModRtmData,
  fetchModGDamDefault,
  fetchModDamDefault,
  fetchModDemandDefault,
  fetchModRtmDefault,
  ModStagePost,
  // ModGDamData,
  // ModDamData,
  // ModDemandData,
  // ModRtmData,
} from "../../../../Rest_api/DemoRestApi";
// import { getPriceForecastIEXDaily } from "../../../../Rest_api/RestApi";
import { ModLoadDataUpdate } from "../../../../store/state/ModLoadState";
import DamPriceAnalysis from "./DamAnalysis";
import GDamPriceAnalysis from "./GdamAnalysis";
import RtmPriceAnalysis from "./RtmAnalysis";
// import IexDaily from "./DailyAverageAnalysis";
// import { formatDateToLocal } from "../../../Dashboard/PriceForcating/PriceForcastingIEXDAM";
import DemandPriceAnalysis from "./DemandAnalysis";
import LoadPriceTable from "./LoadTable";
import Tooltip from "../../../../components/tooltip";
import BlockRangeSelector from "../../../../components/BlockRangeSelector/BlockRangeSelector";
import CombinedChartAnalysis from "./MergeChartAnalysis";
import { useMeritEngineNavigation } from "../useMeritEngineNavigation";
import MainHeader from "../DateSession";
import { ErrorPopup } from "../../../../components/ErrorHandling";

const DataTabs = ["Chart", "Table"];
const ChartTabs = ["Detailed", "Aggregated"];

export default function ModPriceAnalysis() {
  const [selectedBlock, setSelectedBlock] = useState<any[]>([]);
  const [activeTab, setActiveTab] = useState(DataTabs[0]);
  const [chartTab, setChartTab] = useState(ChartTabs[0]);
  const preSelectedDate = useSelector(
    (state: any) => state.modDemoDate.selectedDate
  );
  const modSelectedSession = useSelector(
    (state: any) => state.modDemoSession.modSession
  );
  // No need to get loadData from Redux here since we access it inside callbacks
  const { navigateToPage } = useMeritEngineNavigation();
  const location = useLocation();
  const dispatch = useDispatch();
  const [loadingGDam, setLoadingGDam] = useState(false);
  const [dataGDam, setDataGDam] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [loadingDam, setLoadingDam] = useState(false);
  const [dataDam, setDataDam] = useState<any[]>([]);
  const [loadingRtm, setLoadingRtm] = useState(false);
  const [dataRtm, setDataRtm] = useState<any[]>([]);
  // const [loadingDaily, setLoadingDaily] = useState(false);
  // const [dataDaily, setDataDaily] = useState<any[]>([]);
  const [loadingDemand, setLoadingDemand] = useState(false);
  const [dataDemand, setDataDemand] = useState<any[]>([]);
  const demandClearedRef = useRef(false); // prevent double clearing
  const dataFetchedRef = useRef<string | null>(null); // track if data was fetched for current session
  const [error, setError] = useState<string | null>(null);

  const GotoUploadBulk = async () => {
    try {
      setLoading(true);
      const res = await ModStagePost("GENERATION", modSelectedSession);

      if (res) {
        navigateToPage("resources");
      }
    } catch (error) {
      setError("GENERATION failed");
    } finally {
      setLoading(false);
    }
  };

  const getInitialDates = useCallback(() => {
    if (preSelectedDate) {
      // If preSelectedDate is just a day (e.g., "06"), use the month/year from today or a default
      let dateStr =
        preSelectedDate.length === 2
          ? `${new Date().getFullYear()}-${(new Date().getMonth() + 1)
              .toString()
              .padStart(2, "0")}-${preSelectedDate.padStart(2, "0")}`
          : preSelectedDate;

      // If preSelectedDate is in YYYY-MM-DD format, use as is
      if (preSelectedDate.length === 10) {
        dateStr = preSelectedDate;
      }

      const selected = new Date(dateStr);

      // If the selected date is valid
      if (!isNaN(selected.getTime())) {
        // End date is the day before the selected date
        const endDate = new Date(selected);
        endDate.setDate(selected.getDate() - 1);
        endDate.setHours(0, 0, 0, 0);

        // Start date is 6 days before end date
        const startDate = new Date(endDate);
        startDate.setDate(endDate.getDate() - 6);
        startDate.setHours(0, 0, 0, 0);

        return {
          startDate: new Date(startDate.toISOString()),
          endDate: new Date(endDate.toISOString()),
          key: "selection",
        };
      }
    }
    // Default: full month of July 2025
    return {
      startDate: new Date("2025-07-01T00:00:00.000Z"),
      endDate: new Date("2025-07-30T23:59:59.999Z"),
      key: "selection",
    };
  }, [preSelectedDate]);
  const fetchGDamData = useCallback(async () => {
    if (!preSelectedDate || !modSelectedSession) return;
    try {
      setLoadingGDam(true);
      let data;
      let jsonUploadData;

      // Always fetch from API to ensure fresh data
      const aa = await fetchModGDamData(preSelectedDate, modSelectedSession);
      // console.log("GDam API response:", aa);

      // If regular data is empty, try to get default data
      let gdamData = aa.data;
      if (!gdamData || gdamData.length === 0) {
        // console.log("GDam data is empty, trying default data...");
        const defaultResponse = await fetchModGDamDefault(
          preSelectedDate,
          modSelectedSession
        );
        // console.log("GDam Default API response:", defaultResponse);
        gdamData = defaultResponse.data;
      }

      jsonUploadData = {
        date: preSelectedDate,
        session: modSelectedSession,
        data: gdamData,
      };

      // await ModGDamData(jsonUploadData);

      const gdamDate = preSelectedDate;
      const transformedData = gdamData.map((item: any) => ({
        time_slot: item.time_slot,
        date: gdamDate,
        wt_mcp_rs_mwh: item.mcp_rs_mwh,
        previous_mcp_rs_mwh: item.previous_mcp_rs_mwh,
      }));

      const dispatchData = (gdamData as any)?.map((item: any) => {
        return {
          "Time Slot": item.time_slot,
          "Price (Rs/MWh)": item.mcp_rs_mwh,
        };
      });

      dispatch(ModLoadDataUpdate({ type: "gdam", data: dispatchData }));
      setDataGDam(transformedData);
      // console.log("GDam data fetched and set:", transformedData.length, "items");
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingGDam(false);
    }
  }, [preSelectedDate, modSelectedSession, dispatch]);

  const fetchDamData = useCallback(async () => {
    if (!preSelectedDate || !modSelectedSession) return;
    try {
      setLoadingDam(true);
      let data;
      let jsonUploadData;

      // Always fetch from API to ensure fresh data
      const aa = await fetchModDamData(preSelectedDate, modSelectedSession);
      // console.log("Dam API response:", aa);

      // If regular data is empty, try to get default data
      let damData = aa.data;
      if (!damData || damData.length === 0) {
        // console.log("Dam data is empty, trying default data...");
        const defaultResponse = await fetchModDamDefault(
          preSelectedDate,
          modSelectedSession
        );
        // console.log("Dam Default API response:", defaultResponse);
        damData = defaultResponse.data;
      }

      jsonUploadData = {
        date: preSelectedDate,
        session: modSelectedSession,
        data: damData,
      };

      // await ModDamData(jsonUploadData);

      const damDate = preSelectedDate;
      const transformedData = damData.map((item: any) => ({
        time_slot: item.time_slot,
        date: damDate,
        wt_mcp_rs_mwh: item.mcp_rs_mwh,
        previous_mcp_rs_mwh: item.previous_mcp_rs_mwh,
      }));

      const dispatchData = (damData as any)?.map((item: any) => {
        return {
          "Time Slot": item.time_slot,
          "Price (Rs/MWh)": item.mcp_rs_mwh,
        };
      });

      dispatch(ModLoadDataUpdate({ type: "dam", data: dispatchData }));
      setDataDam(transformedData);
      // console.log("Dam data fetched and set:", transformedData.length, "items");
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingDam(false);
    }
  }, [preSelectedDate, modSelectedSession, dispatch]);

  const fetchRtmData = useCallback(async () => {
    if (!preSelectedDate || !modSelectedSession) return;
    try {
      setLoadingRtm(true);
      let data;
      let jsonUploadData;

      // Always fetch from API to ensure fresh data
      const aa = await fetchModRtmData(preSelectedDate, modSelectedSession);
      // console.log("RTM API response:", aa);

      // If regular data is empty, try to get default data
      let rtmData = aa.data;
      if (!rtmData || rtmData.length === 0) {
        // console.log("RTM data is empty, trying default data...");
        const defaultResponse = await fetchModRtmDefault(
          preSelectedDate,
          modSelectedSession
        );
        // console.log("RTM Default API response:", defaultResponse);
        rtmData = defaultResponse.data;
      }

      jsonUploadData = {
        date: preSelectedDate,
        session: modSelectedSession,
        data: rtmData,
      };
      const rtmDate = preSelectedDate;

      // await ModRtmData(jsonUploadData);
      const transformedData = rtmData.map((item: any) => ({
        time_slot: item.time_slot,
        date: rtmDate,
        wt_mcp_rs_mwh: item.mcp_rs_mwh,
        previous_mcp_rs_mwh: item.previous_mcp_rs_mwh,
      }));
      const dispatchData = rtmData?.map((item: any) => {
        return {
          "Time Slot": item.time_slot,
          "Price (Rs/MWh)": item.mcp_rs_mwh,
        };
      });
      dispatch(ModLoadDataUpdate({ type: "rtm", data: dispatchData }));

      setDataRtm(transformedData);
      // console.log("RTM data fetched and set:", transformedData.length, "items");
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingRtm(false);
    }
  }, [preSelectedDate, modSelectedSession, dispatch]);

  // const fetchDailyData = useCallback(async () => {
  //   try {
  //     setLoadingDaily(true);
  //     const dates = getInitialDates();
  //     const startDateStr = formatDateToLocal(dates.startDate);
  //     const endDateStr = formatDateToLocal(dates.endDate);
  //     const newData = await getPriceForecastIEXDaily(startDateStr, endDateStr);

  //     const transformedData = newData.map((item: any) => ({
  //       ...item,
  //       actual_mcp: item.actual_mcp,
  //       forecasted_mcp: item.forecasted_mcp,
  //     }));
  //     const dispatchData = newData.map((item: any) => {
  //       return {
  //         Date: item.date,
  //         "Actual (Avg)": item.actual_mcp,
  //         "Actual (Wtg. Avg)": item.actual_wt_avg_mcp,
  //       };
  //     });
  //     dispatch(ModLoadDataUpdate({ type: "dailyAverage", data: dispatchData }));
  //     setDataDaily(transformedData);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   } finally {
  //     setLoadingDaily(false);
  //   }
  // }, [dispatch, getInitialDates]);

  const fetchDemandData = useCallback(async () => {
    if (!preSelectedDate || !modSelectedSession) return;
    // If just cleared (new session) ensure we fetch fresh; leaving as-is

    try {
      setLoadingDemand(true);
      let data;
      let jsonUploadData;

      // Always fetch from API to ensure fresh data
      const aa = await fetchModDemandData(preSelectedDate, modSelectedSession);
      // console.log("Demand API response:", aa);

      // If regular data is empty, try to get default data
      let demandData = aa.data;
      if (!demandData || demandData.length === 0) {
        // console.log("Demand data is empty, trying default data...");
        const defaultResponse = await fetchModDemandDefault(
          preSelectedDate,
          modSelectedSession
        );
        // console.log("Demand Default API response:", defaultResponse);
        demandData = defaultResponse.data;
      }

      jsonUploadData = {
        date: preSelectedDate,
        session: modSelectedSession,
        data: demandData,
      };
      const demandDate = preSelectedDate;

      // await ModDemandData(jsonUploadData);

      const transformedData = demandData.map((item: any) => ({
        time_slot: item.time_slot,
        date: demandDate,
        target_day: item.demand_mw,
        previous_target_day: item.previous_demand_mw,
      }));
      const dispatchData = demandData?.map((item: any) => ({
        Date: demandDate,
        Demand: item.demand_mw,
      }));
      dispatch(ModLoadDataUpdate({ type: "demand", data: dispatchData }));
      setDataDemand(transformedData);
      // console.log("Demand data fetched and set:", transformedData.length, "items");
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingDemand(false);
    }
  }, [dispatch, modSelectedSession, preSelectedDate]);

  // CLEAR all data whenever a NEW session/date is set (right after navigating from Create Session)
  useEffect(() => {
    if (!preSelectedDate || !modSelectedSession) return;
    // Clear only once per (date, session) pair
    demandClearedRef.current = false;

    // Clear all data to force refetch when navigating back
    setDataDemand([]);
    setDataGDam([]);
    setDataDam([]);
    setDataRtm([]);

    dispatch(ModLoadDataUpdate({ type: "demand", data: [] }));
    dispatch(ModLoadDataUpdate({ type: "gdam", data: [] }));
    dispatch(ModLoadDataUpdate({ type: "dam", data: [] }));
    dispatch(ModLoadDataUpdate({ type: "rtm", data: [] }));

    // Reset the fetch tracking when session/date changes
    dataFetchedRef.current = null;
  }, [preSelectedDate, modSelectedSession, dispatch]);

  // Fetch data when component mounts or when we navigate back to this page
  useEffect(() => {
    // console.log("Fetch useEffect triggered:", { preSelectedDate, modSelectedSession });
    // Only fetch if we have the required data (date and session)
    if (preSelectedDate && modSelectedSession) {
      const sessionKey = `${preSelectedDate}-${modSelectedSession}`;

      // Always fetch data when session/date/token changes, regardless of previous fetch
      // console.log("Starting to fetch all data...");
      fetchGDamData();
      fetchDamData();
      fetchRtmData();
      // fetchDailyData();
      fetchDemandData();
      dataFetchedRef.current = sessionKey;
    }
  }, [
    preSelectedDate,
    modSelectedSession,
    fetchDamData,
    fetchRtmData,
    // fetchDailyData,
    fetchDemandData,
    fetchGDamData,
  ]);

  function isAcceptDisabled() {
    if (!preSelectedDate || !modSelectedSession) {
      return true;
    }
    if (loadingDam || loadingRtm || loadingGDam || loadingDemand) {
      return true;
    }
    if (
      dataRtm.length === 0 ||
      dataDam.length === 0 ||
      dataGDam.length === 0 ||
      dataDemand.length === 0
    ) {
      return true;
    }
    return false;
  }
  return (
    <>
      <div className="w-full">
        <MainHeader />

        <div className="h-[calc(-73px+100vh)] p-4">
          <div className="w-full h-full flex flex-col gap-4">
            <ModHeader title="Load & Market Rates Projection" />
            <div
              className="gas-chart-container "
              style={{ height: "calc(-92px + 100vh)" }}
            >
              <div className="flex justify-between items-center mb-2 border-b border-[#DFEAF2] pb-2">
                <div className="flex items-center gap-3">
                  <ToggleTabs
                    tabs={DataTabs}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                  />
                  <BlockRangeSelector
                    blocks={Array.from({ length: 96 }, (_, i) => i + 1)}
                    placeholder="Select Block"
                    selectedOptions={selectedBlock.map((item) => item.value)}
                    setSelectedOptions={setSelectedBlock}
                  />
                </div>

                <div className="flex gap-x-6 justify-end">
                  {activeTab === "Chart" && (
                    <ToggleTabs
                      tabs={ChartTabs}
                      activeTab={chartTab}
                      setActiveTab={setChartTab}
                    />
                  )}
                  <DownloadBtn />
                  <button
                    disabled={isAcceptDisabled()}
                    onClick={GotoUploadBulk}
                    className="flex items-center gap-2 p-3 text-sm rounded-xl disabled:text-[#A9A8B1] disabled:bg-[#E2E2E5] bg-[#F1935C] text-white font-medium"
                  >
                    {loading ? "Processing..." : "Accept & Advance"}
                  </button>
                </div>
              </div>
              {activeTab === "Chart" ? (
                <>
                  {chartTab === "Detailed" ? (
                    <>
                      {" "}
                      <div className="load-data grid grid-cols-1 md:grid-cols-12 grid-rows-full md:grid-rows-2 gap-4 h-full w-full md:overflow-hidden">
                        <DemandPriceAnalysis
                          loading={loadingDemand}
                          data={dataDemand}
                          setData={setDataDemand}
                          selectedBlock={selectedBlock}
                        />
                        <GDamPriceAnalysis
                          selectedBlock={selectedBlock}
                          loading={loadingGDam}
                          data={dataGDam}
                          setData={setDataGDam}
                        />
                        {/* <IexDaily
                          loading={loadingDaily}
                          data={dataDaily}
                          setData={setDataDaily}
                        /> */}
                        <DamPriceAnalysis
                          selectedBlock={selectedBlock}
                          loading={loadingDam}
                          data={dataDam}
                          setData={setDataDam}
                        />

                        <RtmPriceAnalysis
                          selectedBlock={selectedBlock}
                          loading={loadingRtm}
                          data={dataRtm}
                          setData={setDataRtm}
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      <CombinedChartAnalysis
                        selectedBlock={selectedBlock}
                        dataDam={dataDam}
                        dataGDam={dataGDam}
                        dataRtm={dataRtm}
                        dataDemand={dataDemand}
                        setDamData={setDataDam}
                        setGDamData={setDataGDam}
                        setRtmData={setDataRtm}
                        setDemandData={setDataDemand}
                      />
                    </>
                  )}
                </>
              ) : (
                <LoadPriceTable
                  selectedBlock={selectedBlock}
                  loading={loadingDam}
                  dataDam={dataDam}
                  dataGDam={dataGDam}
                  dataRtm={dataRtm}
                  dataDemand={dataDemand}
                  setData={setDataDam}
                />
              )}
            </div>
            <ErrorPopup error={error} onClose={() => setError(null)} />
            <div className="gna-footer-container">
              <div className="grid grid-cols-3 justify-between gap-5 ">
                <Tooltip
                  note={<p>IEX DAM and RTM: Daily Market Snapshot</p>}
                  text=" Anticipated Load and Price are Forcasted.
             "
                >
                  <p className="gna-footer-text">Source</p>
                </Tooltip>
                <p className="gna-footer-text col-span-1 text-center">
                  Powered by <strong>GNA Energy</strong>
                </p>
                <strong className="gna-footer-text col-span-1 text-end">
                  Beta Version
                </strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function DownloadBtn() {
  const data = useSelector((state: any) => state.modLoad.data);
  const handleDownload = () => {
    const table = document.getElementById("my-table_load");
    if (!table) {
      alert("Table is not visible right now!");
      return;
    }
    const worksheet = XLSX.utils.table_to_sheet(table);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, "mod_load_data.xlsx");
  };

  // const handleDownload = () => {
  //   // Prepare sheets for each key in data
  //   const workbook = XLSX.utils.book_new();

  //   Object.entries(data).forEach(([key, arr]) => {
  //     if (Array.isArray(arr) && arr.length > 0) {
  //       const ws = XLSX.utils.json_to_sheet(arr);
  //       XLSX.utils.book_append_sheet(workbook, ws, key);
  //     }
  //   });

  //   // Generate Excel file and trigger download
  //   const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  //   saveAs(
  //     new Blob([wbout], { type: "application/octet-stream" }),
  //     "mod_load_data.xlsx"
  //   );
  // };
  return (
    <button
      onClick={handleDownload}
      className="flex items-center gap-2 px-3 text-sm rounded-xl bg-[#FFFAF6] text-[#F1935C] font-medium border border-[#F1935C]"
    >
      <span> Download Data</span>
      <Download className="w-5 h-5" />
    </button>
  );
}
